<template>
  <div class="privacy-policy">
    <div class="header">
      <h1>Datenschutzerklärung</h1>
    </div>

    <div class="main">
      <section class="lead">
        <p>Liebe Besucherin, lieber Besucher unserer Website,</p>
        <p>
          wir als Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr
          ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und gemäß den
          geltenden Datenschutzvorschriften.
        </p>
        <p>
          Mit dieser Datenschutzerklärung möchten wir Sie darüber informieren, welche
          personenbezogenen Daten von Ihnen beim Besuch dieser Website erhoben werden
          und wozu wir diese Daten nutzen.
        </p>
        <p>
          Ebenso enthält diese Datenschutzerklärung eine Zusammenstellung Ihrer Rechte im
          Zusammenhang mit Ihren personenbezogenen Daten. Zögern Sie nicht uns
          anzusprechen, wenn Sie Fragen haben.
        </p>
      </section>

      <section>
        <h2>1. Begriffsbestimmungen</h2>
        <p>
          Nach dem Vorbild des Art. 4 DSGVO (Datenschutzgrundverordnung) liegen dieser
          Datenschutzerklärung folgende Begriffsbestimmungen zugrunde:
        </p>
        <ul>
          <li>
            <strong>"Personenbezogene Daten"</strong> (Art. 4 Nr. 1 DSGVO) sind alle Informationen, die
            sich auf eine identifizierte oder identifizierbare natürliche Person ("Betroffener")
            beziehen. Identifizierbar ist eine Person, wenn sie direkt oder indirekt,
            insbesondere mittels Zuordnung zu einer Kennung wie einem Namen, einer
            Kennnummer, einer Online-Kennung, Standortdaten oder mithilfe von
            Informationen zu ihren physischen, physiologischen, genetischen, psychischen,
            wirtschaftlichen, kulturellen oder sozialen Identitätsmerkmalen identifiziert
            werden kann. Die Identifizierbarkeit kann auch mittels einer Verknüpfung von
            derartigen Informationen oder anderem Zusatzwissen gegeben sein. Auf das
            Zustandekommen, die Form oder die Verkörperung der Informationen kommt
            es nicht an (auch Fotos, Video- oder Tonaufnahmen können
            personenbezogene Daten enthalten).
          </li>
          <li>
            <strong>"Verarbeiten"</strong> (Art. 4 Nr. 2 DSGVO) ist jeder Vorgang, bei dem mit
            personenbezogenen Daten umgegangen wird, gleich ob mit oder ohne Hilfe
            automatisierter (d.h. technikgestützter) Verfahren. Dies umfasst insbesondere
            das Erheben (d.h. die Beschaffung), das Erfassen, die Organisation, das
            Ordnen, die Speicherung, die Anpassung oder Veränderung, das Auslesen, das
            Abfragen, die Verwendung, die Offenlegung durch Übermittlung, die
            Verbreitung oder sonstige Bereitstellung, den Abgleich, die Verknüpfung, die
            Einschränkung, das Löschen oder die Vernichtung von personenbezogenen
            Daten sowie die Änderung einer Ziel- oder Zweckbestimmung, die einer
            Datenverarbeitung ursprünglich zugrunde gelegt wurde.
          </li>
          <li>
            <strong>"Verantwortlicher"</strong> (Art. 4 Nr. 7 DSGVO) ist die natürliche oder juristische
            Person, Behörde, Einrichtung oder andere Stelle, die allein oder gemeinsam
            mit anderen über die Zwecke und Mittel der Verarbeitung von
            personenbezogenen Daten entscheidet.
          </li>
          <li>
            <strong>"Dritter"</strong> (Art. 4 Nr. 10 DSGVO) ist jede natürliche oder juristische Person,
            Behörde, Einrichtung oder andere Stelle außer dem Betroffenen, dem
            Verantwortlichen, dem Auftragsverarbeiter und den Personen, die unter der
            unmittelbaren Verantwortung des Verantwortlichen oder Auftragsverarbeiters
            befugt sind, die personenbezogenen Daten zu verarbeiten; dazu gehören auch
            andere konzernangehörige juristische Personen.
          </li>
          <li>
            <strong>"Auftragsverarbeiter"</strong> (Art. 4 Nr. 8 DSGVO) ist eine natürliche oder juristische
            Person, Behörde, Einrichtung oder andere Stelle, die personenbezogene Daten
            im Auftrag des Verantwortlichen, insbesondere gemäß dessen Weisungen,
            verarbeitet (z.B. IT-Dienstleister). Im datenschutzrechtlichen Sinne ist ein
            Auftragsverarbeiter insbesondere kein Dritter.
          </li>
          <li>
            <strong>"Einwilligung"</strong> (Art. 4 Nr. 11 DSGVO) der betroffenen Person bezeichnet jede
            freiwillig für den bestimmten Fall, in informierter Weise und unmissverständlich
            abgegebene Willensbekundung in Form einer Erklärung oder einer sonstigen
            eindeutigen bestätigenden Handlung, mit der die betroffene Person zu
            verstehen gibt, dass sie mit der Verarbeitung der sie betreffenden
            personenbezogenen Daten einverstanden ist.
          </li>
        </ul>
      </section>

      <section>
        <h2>2. Verantwortlich für die Datenverarbeitung</h2>
        <p>Verantwortlicher gem. Art. 4 Abs. 7 DSGVO ist:</p>
        <ContactComp />
      </section>

      <section>
        <h2>3. Rechtsgrundlagen der Datenverarbeitung</h2>
        <p>
          Von Gesetzes wegen ist im Grundsatz jede Verarbeitung personenbezogener Daten
          verboten und nur dann erlaubt, wenn die Datenverarbeitung unter einen der folgenden
          Rechtfertigungstatbestände fällt:
        </p>
        <ul>
          <li id="art6a">
            <strong>Art. 6 Abs. 1 S. 1 lit. a DSGVO ("Einwilligung"):</strong> Wenn der Betroffene freiwillig,
            in informierter Weise und unmissverständlich durch eine Erklärung oder eine
            sonstige eindeutige bestätigende Handlung zu verstehen gegeben hat, dass er
            mit der Verarbeitung der ihn betreffenden personenbezogenen Daten für
            einen oder mehrere bestimmte Zwecke einverstanden ist;
          </li>
          <li>
            <strong>Art. 6 Abs. 1 S. 1 lit. b DSGVO:</strong> Wenn die Verarbeitung zur Erfüllung eines
            Vertrags, dessen Vertragspartei der Betroffene ist, oder zur Durchführung
            vorvertraglicher Maßnahmen erforderlich ist, die auf die Anfrage des
            Betroffenen erfolgen;
          </li>
          <li>
            <strong>Art. 6 Abs. 1 S. 1 lit. c DSGVO:</strong> Wenn die Verarbeitung zur Erfüllung einer
            rechtlichen Verpflichtung erforderlich ist, der der Verantwortliche unterliegt (z. B.
            eine gesetzliche Aufbewahrungspflicht);
          </li>
          <li>
            <strong>Art. 6 Abs. 1 S. 1 lit. d DSGVO:</strong> Wenn die Verarbeitung erforderlich ist, um
            lebenswichtige Interessen des Betroffenen oder einer anderen natürlichen
            Person zu schützen;
          </li>
          <li>
            <strong>Art. 6 Abs. 1 S. 1 lit. e DSGVO:</strong> Wenn die Verarbeitung für die Wahrnehmung
            einer Aufgabe erforderlich ist, die im öffentlichen Interesse liegt oder in
            Ausübung öffentlicher Gewalt erfolgt, die dem Verantwortlichen übertragen
            wurde oder
          </li>
          <li id="art6f">
            <strong>Art. 6 Abs. 1 S. 1 lit. f DSGVO ("Berechtigte Interessen"):</strong> Wenn die
            Verarbeitung zur Wahrung berechtigter (insbesondere rechtlicher oder
            wirtschaftlicher) Interessen des Verantwortlichen oder eines Dritten erforderlich
            ist, sofern nicht die gegenläufigen Interessen oder Rechte des Betroffenen
            überwiegen (insbesondere dann, wenn es sich dabei um einen Minderjährigen
            handelt).
          </li>
        </ul>
        <p>
          Die Speicherung von Informationen in der Endeinrichtung des Endnutzers oder der
          Zugriff auf Informationen, die bereits in der Endeinrichtung gespeichert sind, sind nur
          zulässig, wenn sie von einem der folgenden Rechtfertigungstatbeständen gedeckt sind:
        </p>
        <ul>
          <li>
            <strong>§ 25 Abs. 1 TDDDG:</strong> Wenn der Endnutzer auf der Grundlage von klaren und
            umfassenden Informationen eingewilligt hat. Die Einwilligung hat gem. Art. 6
            Abs. 1 S. 1 lit. a DSGVO zu erfolgen;
          </li>
          <li>
            <strong>§ 25 Abs. 2 Nr. 1 TDDDG:</strong> Wenn der alleinige Zweck die Durchführung der Übertragung
            einer Nachricht über ein öffentliches Telekommunikationsnetz ist oder
          </li>
          <li>
            <strong>§ 25 Abs. 2 Nr. 2 TDDDG:</strong> Wenn die Speicherung oder der Zugriff unbedingt
            erforderlich ist, damit der Anbieter eines Telemediendienstes einen vom Nutzer
            ausdrücklich gewünschten Telemediendienst zur Verfügung stellen kann.
          </li>
        </ul>
        <p>
          Für die von uns vorgenommenen Verarbeitungsvorgänge geben wir im Folgenden
          jeweils die anwendbare Rechtsgrundlage an. Eine Verarbeitung kann auch auf
          mehreren Rechtsgrundlagen beruhen.
        </p>
      </section>

      <section>
        <h2>4. Ihre Rechte</h2>
        <p>Sie haben das Recht,</p>
        <ul>
          <li>
            gemäß Art. 15 DSGVO <strong>Auskunft</strong> über Ihre von uns verarbeiteten
            personenbezogenen Daten zu verlangen. Insbesondere können Sie Auskunft
            über die Verarbeitungszwecke, die Kategorie der personenbezogenen Daten,
            die Kategorien von Empfängern, gegenüber denen Ihre Daten offengelegt
            wurden oder werden, die geplante Speicherdauer, das Bestehen eines Rechtes
            auf Berichtigung, Löschung, Einschränkung der Verarbeitung oder
            Widerspruch, das Bestehen eines Beschwerderechts, die Herkunft Ihrer Daten,
            sofern diese nicht bei uns erhoben wurden, sowie über das Bestehen einer
            automatisierten Entscheidungsfindung einschließlich Profiling und
            gegebenenfalls aussagekräftigen Informationen zu deren Einzelheiten
            verlangen;
          </li>
          <li>
            gemäß Art. 16 DSGVO unverzüglich die <strong>Berichtigung</strong> unrichtiger oder
            <strong>Vervollständigung</strong> Ihrer bei uns gespeicherten personenbezogener Daten zu
            verlangen;
          </li>
          <li>
            gemäß Art. 17 DSGVO die <strong>Löschung</strong> Ihrer bei uns gespeicherten
            personenbezogenen Daten zu verlangen, soweit nicht die Verarbeitung zur
            Ausübung des Rechts auf freie Meinungsäußerung und Information, zur
            Erfüllung einer rechtlichen Verpflichtung, aus Gründen des öffentlichen
            Interesses oder zur Geltendmachung, Ausübung oder Verteidigung von
            Rechtsansprüchen erforderlich ist;
          </li>
          <li>
            gemäß Art. 18 DSGVO die <strong>Einschränkung der Verarbeitung</strong> Ihrer
            personenbezogenen Daten zu verlangen, soweit die Richtigkeit der Daten von
            Ihnen bestritten wird, die Verarbeitung unrechtmäßig ist, Sie aber deren
            Löschung ablehnen und wir die Daten nicht mehr benötigen, Sie jedoch diese
            zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen
            benötigen oder Sie gemäß Art. 21 DSGVO Widerspruch gegen die
            Verarbeitung eingelegt haben;
          </li>
          <li>
            gemäß Art. 20 DSGVO Ihre personenbezogenen Daten, die Sie uns
            bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren
            Format zu erhalten oder die Übermittlung an einen anderen Verantwortlichen
            zu verlangen (<strong>Datenübertragbarkeit</strong>);
          </li>
          <li>
            gemäß Art. 7 Abs. 3 DSGVO Ihre einmal erteilte <strong>Einwilligung</strong> jederzeit
            gegenüber uns zu <strong>widerrufen</strong>. Dies hat zur Folge, dass wir die
            Datenverarbeitung, die auf dieser Einwilligung beruhte, für die Zukunft nicht
            mehr fortführen dürfen und
          </li>
          <li>
            gemäß Art. 77 DSGVO sich bei einer <strong>Aufsichtsbehörde</strong> zu <strong>beschweren</strong>.
            In der Regel können Sie sich hierfür an die Aufsichtsbehörde Ihres üblichen
            Aufenthaltsortes oder Arbeitsplatz oder unseres Sitzes wenden.
          </li>
        </ul>
        <p>Zuständige Aufsichtsbehörde ist die:</p>
        <p><strong>Landesbeauftragte für Datenschutz und Informationstechnik Nordrhein-Westfalen</strong></p>
        <p class="left-padding-class">
          Adresse:  Postfach 20 04 44, 40102 Düsseldorf<br>
          Telefon:  +49 (0)211 / 38424 - 0<br>
          E-Mail:   poststelle@ldi.nrw.de
        </p>
      </section>

      <section>
        <h2>5. Ihr Recht zum Widerspruch</h2>
        <p>
          Wenn wir Ihre personenbezogenen Daten zur Wahrung berechtigter Interessen auf
          Grundlage des Art. 6 Abs. 1 S. 1 f) DSGVO verarbeiten, haben Sie nach Art. 21
          DSGVO das Recht, gegen die Verarbeitung Ihrer personenbezogener Daten
          Widerspruch einzulegen, soweit dafür Gründe vorliegen, die sich aus Ihrer besonderen
          Situation ergeben oder sich der Widerspruch gegen Direktwerbung richtet.
        </p>
        <p>
          Für den Fall des Widerspruchs gegen Direktwerbung haben Sie ein generelles
          Widerspruchsrecht, das ohne Angabe einer besonderen Situation ausgeübt werden
          kann.
        </p>
        <p>
          Wenn Sie von Ihrem Widerrufs- oder Widerspruchsrecht Gebrauch machen wollen,
          reicht eine E-Mail an <a :href="`mailto:${STRINGS.EMAIL}`">{{ STRINGS.EMAIL }}</a> aus.
        </p>
      </section>

      <section>
        <h2>6. Datensicherheit</h2>
        <p>
          Wir bedienen uns geeigneter technischer und organisatorischer
          Sicherheitsmaßnahmen, um Ihre Daten gegen zufällige oder vorsätzliche
          Manipulationen, teilweisen oder vollständigen Verlust, Zerstörung oder gegen den
          unbefugten Zugriff Dritter zu schützen (z.B. TLS-Verschlüsselung für unsere
          Webseite) unter Berücksichtigung des Stands der Technik, der
          Implementierungskosten und der Natur, des Umfangs, des Kontextes und des Zwecks
          der Verarbeitung sowie der bestehenden Risiken einer Datenpanne (inklusive von
          deren Wahrscheinlichkeit und Auswirkungen) für den Betroffenen. Unsere
          Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung
          fortlaufend verbessert.
        </p>
      </section>

      <section>
        <h2>7. Datenweitergabe an Dritte</h2>
        <p>
          Wie bei jeder Praxis, setzen auch wir zur Abwicklung unseres Geschäftsverkehrs
          externe in- und ausländische Dienstleister ein (z.B. für die Bereiche IT,
          Telekommunikation, Vertrieb und Marketing). Diese werden nur nach unserer Weisung
          tätig und wurden i.S.v. Art. 28 DSGVO vertraglich dazu verpflichtet, die
          datenschutzrechtlichen Bestimmungen einzuhalten.
        </p>
        <p>
          Folgende Kategorien von Empfängern, bei denen es sich im Regelfall um
          Auftragsverarbeiter handelt, erhalten ggf. Zugriff auf Ihre personenbezogenen Daten:
        </p>
        <ul>
          <li>
            Dienstleister für den Betrieb unserer Webseite und die Verarbeitung der durch die
            Systeme gespeicherten oder übermittelten Daten (z.B. für Rechenzentrumsleistungen
            oder IT-Sicherheit). Rechtsgrundlage für die Weitergabe ist dann Art. 6 Abs. 1 S. 1 lit.
            b oder lit. f DSGVO, soweit es sich nicht um Auftragsverarbeiter handelt;
          </li>
          <li>
            Staatliche Stellen/Behörden, soweit dies zur Erfüllung einer gesetzlichen
            Verpflichtung erforderlich ist. Rechtsgrundlage für die Weitergabe ist dann Art. 6 Abs.
            1 S. 1 lit. c DSGVO;
          </li>
          <li>
            Zur Durchführung unseres Geschäftsbetriebs eingesetzte Personen (z.B. Auditoren,
            Aufsichtsbehörden, Rechtsberater, Versicherungen). Rechtsgrundlage für die
            Weitergabe ist dann Art. 6 Abs. 1 S. 1 lit. b oder lit. f DSGVO.
          </li>
        </ul>
        <p>
          Darüber hinaus geben wir Ihre personenbezogenen Daten nur an Dritte weiter, wenn
          Sie nach Art. 6 Abs. 1 S. 1 lit. a eine ausdrückliche Einwilligung dazu erteilt haben.
        </p>
        <p>
          Grundsätzlich übermitteln wir Ihre personenbezogenen Daten i.S.v. Art. 9 Abs. 2
          DSGVO (besondere Kategorien personenbezogener Daten) nicht an Dritte. Diese
          geben wir ausschließlich dann weiter, wenn Sie uns nach Art. 9 Abs. 2 lit. a DSGVO
          eine ausdrückliche Einwilligung dazu erteilt haben.
        </p>
      </section>

      <section>
        <h2>8. Hosting</h2>
        <p>
          Unsere Website wird bei <strong>Netlify, Inc.</strong>,
          512 2nd Street, Fl 2, San Francisco, CA 94107, USA, gehostet.
          Wenn Sie unsere Website besuchen, werden durch Netlify verschiedene
          <a href="#personal-data">personenbezogene Daten</a>
          verarbeitet (z.&nbsp;B. IP-Adresse, Zugriffszeitpunkt, Browser-Informationen), 
          um den sicheren und effizienten Betrieb der Website zu gewährleisten.
        </p>
        <p>
          Der Einsatz von Netlify erfolgt auf Grundlage von
          <a href="#art6f">Art. 6 Abs. 1 S. 1 lit. f DSGVO</a>
          Wir haben ein berechtigtes Interesse an einer möglichst zuverlässigen Darstellung und Bereitstellung unserer Website. 
          Soweit eine entsprechende Einwilligung abgefragt wurde (z.&nbsp;B. für Analyse- oder Trackingfunktionen), 
          erfolgt die Verarbeitung ausschließlich auf Grundlage von
          <a href="#art6a">Art. 6 Abs. 1 S. 1 lit. a DSGVO</a>
          ; die Einwilligung ist jederzeit widerrufbar.
        </p>
        <p>
          Die Datenübertragung in die USA erfolgt auf Grundlage der EU-US Data Privacy Frameworks (DPF) sowie auf Grundlage von Standardvertragsklauseln der EU-Kommission. 
          Weitere Informationen finden Sie in der 
          <a href="https://www.netlify.com/privacy/" target="_blank" rel="noopener noreferrer">
            Datenschutzerklärung von Netlify
          </a>.
        </p>
      </section>

      <section>
        <h2>9. Welche Daten erheben und speichern wir und wozu benötigen wir diese?</h2>
        <p>
          Zwar ist die Nutzung unserer Website in der Regel ohne Angabe personenbezogener
          Daten möglich. Im Zusammenhang mit unserem Kontaktformular bzw. unserem
          Angebot an Sie, online Termine zu buchen, sind wir allerdings auf persönliche
          Angaben von Ihnen angewiesen. Ebenso erhebt der Provider bestimmte Daten.
        </p>
        <p>
          Nachstehend informieren wir Sie über die entsprechenden Datenverarbeitungsvorgänge:
        </p>
        <p id="personal-data"><strong>a. Beim Besuch unserer Website</strong></p>
        <p>
          Wenn Sie unsere Website besuchen, werden durch den auf Ihrem Endgerät (z.B.
          Tablet, PC, Mobiltelefon) zum Einsatz kommenden Browser (Programm zur
          Darstellung von Internetseiten) automatisch Informationen an den Server unserer
          Website gesendet. Diese werden temporär in einem Logfile (Protokolldatei)
          gespeichert.
        </p>
        <p>
          Dabei handelt es sich um folgende Informationen, die bis zur automatisierten
          Löschung gespeichert bleiben:
        </p>
        <ul>
          <li>IP-Adresse des anfragenden Rechners,</li>
          <li>Datum und Uhrzeit des Zugriffs,</li>
          <li>Name und URL der abgerufenen Datei/Seite,</li>
          <li>Zugriffsstatus/HTTP-Statuscode</li>
          <li>Website, von der aus der Zugriff erfolgt,</li>
          <li>
            verwendeter Browser und ggf. das Betriebssystem Ihres Rechners sowie der
            Name Ihres Internet-Dienstleister
          </li>
        </ul>
        <p>Diese Daten werden für folgende Zwecke verarbeitet:</p>
        <ul>
          <li>
            Gewährleistung eines reibungslosen Verbindungsaufbaus der Website,
          </li>
          <li>Gewährleistung einer komfortablen Nutzung unserer Website,</li>
          <li>Auswertung der Systemsicherheit und -stabilität sowie</li>
          <li>zu weiteren administrativen Zwecken.</li>
        </ul>
        <p>
          Diese Datenverarbeitung erfolgt auf der Rechtsgrundlage des Art. 6 Abs. 1 S. 1 f)
          DSGVO (berechtigtes Interesse des Verantwortlichen oder eines Dritten). Unser
          berechtigtes Interesse ergibt sich aus den oben aufgelisteten Zwecken der
          Datenerhebung.
        </p>
        <p>
          In keinem Fall verwenden wir die erhobenen Daten zu dem Zweck, Rückschlüsse auf
          Ihre Person zu ziehen.
        </p>
        <p>
          Darüber hinaus werden auf unserer Website Cookies sowie Analysedienste
          eingesetzt. Nähere Erläuterungen dazu finden Sie weiter unten in dieser
          Datenschutzerklärung.
        </p>
        <p><strong>b. Anfrage per E-Mail oder Telefon</strong></p>
        <p>
          Wenn Sie uns per E-Mail oder Telefon kontaktieren, wird Ihre Anfrage inklusive aller
          daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der
          Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben
          wir nicht ohne Ihre Einwilligung weiter.
        </p>
        <p>
          Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO,
          sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur
          Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen
          beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven
          Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
          Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde; die Einwilligung
          ist jederzeit mit Wikrung für die Zukunft widerrufbar.
        </p>
        <p>
          Die von Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben bei uns, bis
          Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder
          der Zweck für die Datenspeicherung entfällt (z. B. unmittelbar nach abgeschlossener
          Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen – insbesondere
          gesetzliche Aufbewahrungsfristen – bleiben unberührt.
        </p>
        <p><strong>c. Online-Rezeption der 321MED GmbH</strong></p>
        <p>
          Diese Website nutzt den Online-Rezeptionsservicedienst 321 MED für die digitale,
          online-basierte Kommunikation und Interaktion zwischen Patienten und
          Gesundheitseinrichtungen und/oder Arztpraxen. Dienstanbieter ist die 321 MED
          GmbH, Wernerwerkstraße 4, 93049 Regensburg.
        </p>
        <p>
          321 MED ermöglicht uns eine unmittelbare Online-Betreuung unserer Patienten sowie
          eine schnelle und unkomplizierte Kommunikation mit unseren Patienten. Wenn Sie auf
          unserer Website über unsere Online-Rezeption Daten, etwa Ihre Kontaktdaten, zum
          Zwecke des der Kommunikation mit uns eingeben, werden diese auf den Servern von
          321 MED in Deutschland gespeichert. Je nach individueller Konfiguration und Eingabe
          werden im Rahmen der Nutzung unseres Online-Rezeptionsdienstes unter
          Umständen personenbezogene Daten und/oder Gesundheitsdaten erfasst.
        </p>
        <p>
          Die Nutzung von 321 MED erfolgt im Interesse einer ansprechenden Darstellung
          unserer Online-Angebote sowie der Bereitstellung eines unmittelbaren und schnellen
          Services. Dies stellt ein berechtigtes Interesse dar, Rechtsgrundlage ist Art. 6 Abs. 1
          lit. f DSGVO. Die Datenverarbeitung mittels 321 MED erfolgt mittels der von Ihnen zur
          Verfügung gestellten/eingegebenen Daten auf Grundlage Ihrer Einwilligung, Art. 6
          Abs. 1 lit. a DSGVO. Soweit Sie optionale Daten wie Geschlecht oder
          Gesundheitsdaten angeben, erfolgt die Datenverarbeitung auf Grundlage Ihrer
          Einwilligung gem. Art. 9 Abs. 2 lit. a DSGVO.
        </p>
        <p>
          Wenn Sie nicht möchten, dass Ihre Daten an 321 MED übertragen werden, können
          Sie Ihre Einwilligung zur Verarbeitung Ihrer personenbezogenen Daten oder
          Gesundheitsdaten jederzeit durch eine Nachricht an uns widerrufen. Wenn Sie Ihre
          Einwilligung widerrufen, werden Ihre Daten bei uns bzw. bei 321 MED gelöscht. Bitte
          beachten Sie, dass Sie in diesem Fall aber möglicherweise nicht (mehr) sämtliche
          Funktionen unseres Online-Rezeptionsdienstes vollständig nutzen können. Daten, die
          zu anderen Zwecken bei uns oder 321 MED gespeichert wurden, bleiben hiervon
          unberührt. Die Rechtmäßigkeit bereits erfolgter Datenverarbeitungsvorgänge bleibt
          vom Widerruf unberührt.
        </p>
        <p>
          Wir haben mit dem Anbieter 321 MED einen datenschutzrechtlich vorgeschriebenen
          Vertrag über Auftragsverarbeitung (AVV) geschlossen. Hierbei handelt es sich um
          einen Vertrag, der gewährleistet, dass der jeweilige Anbieter personenbezogene
          Daten der User unserer Website nur nach unseren Weisungen sowie unter Einhaltung
          der DSGVO verarbeitet.
        </p>
        <p>
          Weitere Informationen zu den via 321 MED verarbeiteten Daten sowie darüber, welche
          Cookies wir verwenden und wie Sie Ihre Cookie-Einstellungen verwalten können,
          finden Sie in der
          <a href="https://321med.com/de/dataprotection" target="_blank" rel="noopener noreferrer">
            Datenschutzerklärung von 321 MED
          </a>
          unter https://321med.com/de/dataprotection.
        </p>
        <p><strong>d. Cookies</strong></p>
        <p>
          Auf unserer Website kommen Cookies zum Einsatz. Dies sind Dateien, die Ihr Browser
          automatisch erstellt und die auf Ihrem Endgerät gespeichert werden, wenn Sie unsere
          Website besuchen. Cookies richten auf Ihrem Endgerät keinen Schaden an, enthalten
          keine Viren, Trojaner oder sonstige Schadsoftware.
        </p>
        <p>
          In dem Cookie werden Informationen gespeichert, die sich jeweils im Zusammenhang
          mit dem spezifisch eingesetzten Endgerät ergeben. Dies bedeutet jedoch nicht, dass
          wir dadurch unmittelbar Kenntnis von Ihrer Identität erhalten.
        </p>
        <p>
          Wir verwenden Cookies einerseits dazu, die Nutzung unseres Web-Angebotes für Sie
          komfortabler zu gestalten. Dabei verwenden wir etwa sog. „Session-Cookies“, die
          erkennen, dass Sie einzelne Seiten unserer Website bereits besucht haben. Diese
          Session-Cookies werden nach Verlassen unserer Seite automatisch gelöscht.
        </p>
        <p>
          Ebenso verwenden wir zur Optimierung der Benutzerfreundlichkeit temporäre
          Cookies, die für einen bestimmten festgelegten Zeitraum auf Ihrem Endgerät
          gespeichert werden. Wenn Sie unsere Website dann erneut besuchen, wird
          automatisch erkannt, dass Sie bereits bei uns waren und welche Eingaben und
          Einstellungen Sie getätigt haben, um diese nicht noch einmal vornehmen zu müssen.
        </p>
        <p>
          Cookies dienen darüber hinaus, die Nutzungsintensität unserer Website statistisch zu
          erfassen und diese Erfassung zur Optimierung unseres Angebotes auszuwerten.
          Diese Analyse (s. unten) macht es uns möglich, bei einem erneuten Besuch unserer
          Website automatisch zu erkennen, dass Sie bereits bei uns waren. Diese Cookies
          werden nach einer jeweils definierten Zeit automatisch gelöscht.
        </p>
        <p>
          Rechtsgrundlage für die Datenerhebung durch die Cookies ist Art. 6 Abs. 1 S. 1 f)
          DSGVO. Die in diesem Zusammenhang stattfindende Datenverarbeitung dient den
          obengenannten Zwecken zur Wahrung unserer berechtigten Interessen. Soweit es
          sich um Cookies handelt, deren Datenverarbeitung über unsere Website hinausgeht,
          ist Rechtsgrundlage für die Datenverarbeitung ihre zuvor eingeholte ausdrückliche
          Einwilligung gemäß Art. 6 Abs. 1 S. 1a) DSGVO.
        </p>
        <p>
          Normalerweise akzeptieren Browser Cookies automatisch. Sie können Ihren Browser
          allerdings so einstellen, dass auf Ihrem Endgerät keine Cookies gespeichert werden
          oder aber ein Hinweis erscheint, bevor ein neuer Cookie angelegt wird. Wir weisen
          aber darauf hin, dass die vollständige Deaktivierung von Cookies dazu führen kann,
          dass Sie nicht alle Funktionen unserer Website nutzen können.
        </p>
      </section>

      <section>
        <h2>10. Analyse-Tools und Werbung</h2>
        <p>Auf unserer Website sind keine Analysetools eingebunden.</p>
      </section>

      <section>
        <h2>11. Plugins</h2>
        <p>
          Wir setzen derzeit folgendes Social-Media-Plug-in ein: Google Maps, welches nur
          geladen wird, wenn Sie zuvor durch Ihre Einwilligung die Funktion aktiviert haben.
          Rechtsgrundlage für die Nutzung des Plug-ins ist Art. 6 Abs. 1 S. 1 lit. a DSGVO, d.h.
          die Einbindung erfolgt nur nach Ihrer Einwilligung.
        </p>
        <p id="google-maps"><strong>Einbindung von Google Maps</strong></p>
        <p>
          Auf dieser Webseite nutzen wir das Angebot von Google Maps. Dadurch können wir
          Ihnen interaktive Karten direkt in der Website anzeigen und ermöglichen Ihnen die
          komfortable Nutzung der Karten-Funktion. Rechtsgrundlage für die Nutzung der
          Karten ist Art. 6 Abs. 1 S. 1 lit. a DSGVO, d.h. die Einbindung erfolgt nur nach Ihrer
          Einwilligung.
        </p>
        <p>
          Durch den Besuch auf der Website erhält Google die Information, dass Sie die
          entsprechende Unterseite unserer Website aufgerufen haben. Zudem werden die
          oben genannten grundlegenden Daten wie IP-Adresse und Zeitstempel übermittelt.
          Dies erfolgt unabhängig davon, ob Google ein Nutzerkonto bereitstellt, über das Sie
          eingeloggt sind, oder ob kein Nutzerkonto besteht. Wenn Sie bei Google eingeloggt
          sind, werden Ihre Daten direkt Ihrem Konto zugeordnet. Wenn Sie die Zuordnung mit
          Ihrem Profil bei Google nicht wünschen, müssen Sie sich vor Aktivierung des Buttons
          ausloggen. Google speichert Ihre Daten als Nutzungsprofile und nutzt sie für Zwecke
          der Werbung, Marktforschung und/oder bedarfsgerechten Gestaltung seiner Website.
          Eine solche Auswertung erfolgt insbesondere (selbst für nicht eingeloggte Nutzer) zur
          Erbringung von bedarfsgerechter Werbung und um andere Nutzer des sozialen
          Netzwerks über Ihre Aktivitäten auf unserer Website zu informieren. Ihnen steht ein
          Widerspruchsrecht zu gegen die Bildung dieser Nutzerprofile, wobei Sie sich zur
          Ausübung dessen an Google richten müssen.
        </p>
        <p>
          Die erhobenen Informationen werden auf Servern von Google, auch in den USA,
          gespeichert. Für diese Fälle hat sich der Anbieter nach eigenen Angaben einen
          Maßstab auferlegt, der dem früheren EU-US Privacy Shield entspricht und hat
          zugesagt, bei der internationalen Datenübermittlung anwendbare Datenschutzgesetze
          einzuhalten. Wir haben zudem sog. Standarddatenschutzklauseln mit Google
          vereinbart, deren Zweck die Einhaltung eines angemessenen Datenschutzniveaus im
          Drittland ist.
        </p>
        <p>
          Weitere Informationen zu Zweck und Umfang der Datenerhebung und ihrer
          Verarbeitung durch den Plug-in-Anbieter erhalten Sie in den Datenschutzerklärungen
          des Anbieters. Dort erhalten Sie auch weitere Informationen zu Ihren diesbezüglichen
          Rechten und Einstellungsmöglichkeiten zum Schutze Ihrer Privatsphäre:
          <a href="https://google.de/intl/de/policies/privacy" target="_blank" rel="noopener noreferrer">
            www.google.de/intl/de/policies/privacy.
          </a>
        </p>
      </section>

      <section>
        <h2>12. Aktualität und Änderung der Datenschutzerklärung</h2>
        <p>
          Diese Datenschutzerklärung ist aktuell gültig und auf dem Stand von 20.10.2025.
        </p>
        <p>
          Die Weiterentwicklung unserer Website bzw. geänderte gesetzliche oder behördliche
          Vorgaben können eine Änderung bzw. Anpassung dieser Datenschutzerklärung
          notwendig machen.
        </p>
      </section>
    </div>

    <section class="legal-note">
      <p>
        Diese Datenschutzerklärung wurde von den Rechtsanwälten der 321 LEGAL GmbH,
        Königswarterstraße 54a, 90762 Fürth,
        <a href="https://321legal.de" target="_blank" rel="noopener noreferrer">
          www.321legal.de
        </a> erstellt.
      </p>
    </section>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { STRINGS } from "@/constants";
import ContactComp from "@/components/ContactComp.vue";

@Options({
  components: {
    ContactComp,
  },
})
export default class PrivacyPolicy extends Vue {
  STRINGS = STRINGS;
}
</script>

<style scoped>
.privacy-policy {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header {
  max-width: 1000px;
  width: 90%;
  text-align: left;
  box-sizing: border-box;
}

.header h1 {
  font-size: 40px;
  margin: 0;
  margin-top: 2rem;
  color: var(--color-text-default);
  word-wrap: break-word;
  hyphens: auto;
}

.main {
  display: flex;
  flex-direction: column;
  align-items: left;
  text-align: left;
  max-width: 1000px;
  width: 90%;
  line-height: 1.5;
}

.privacy-policy .lead p {
  color: var(--color-text-secondary);
  margin-bottom: 0.5rem;
}

.privacy-policy h2 {
  margin-top: 1.1rem;
  margin-bottom: 0.5rem;
  font-size: 1.125rem;
}

.privacy-policy p,
.privacy-policy li {
  color: var(--color-text-default);
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.privacy-policy ul {
  margin-left: 1rem;
}

.privacy-policy a {
  color: var(--color-text-link);
  text-decoration: underline;
}

.left-padding-class {
  padding-left: 1rem;
}

.legal-note {
  text-align: left;
  margin: 1.5rem 0;
  padding: 1rem;
  max-width: 1000px;
  width: 90%;
  border-radius: 8px;
  background: var(--color-background-alt);
}

.legal-note p {
  margin-bottom: 1rem;
}

#art6a, #art6f, #personal-data, #google-maps {
  scroll-margin-top: 180px;
}
</style>
